<script setup lang="ts">
const day = ref<1 | 2 | null>(null)

onMounted(() => {
  if (new Date().toLocaleDateString("ja") === "2025/11/8") {
    day.value = 1
  } else if (new Date().toLocaleDateString("ja") === "2025/11/9") {
    day.value = 2
  } else {
    day.value = 1
  }
})

definePageMeta({
  title: "タイムテーブル",
})
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-[8px] h-[calc(100svh-64px)] md:h-[auto]">
    <div class="flex-grow md:flex-grow-0 mb-4 overflow-x-scroll md:overflow-x-auto max-w-full ">
      <picture v-if="day == 1" >
        <img 
          src="/img/timetable-day1.jpg"
          class="max-h-full max-w-[none] md:max-h-none md:w-full"
        >
      </picture>
      <picture v-if="day == 2" >
        <img 
          src="/img/timetable-day2.jpg"
          class="max-h-full max-w-[none] md:max-h-none md:w-full"
        >
      </picture>
    </div>

    <div class="mb-4 md:mb-0 flex flex-wrap justify-center gap-2">
      <button
        v-if="day == 1 || !day"
        class="btn btn-primary"
        :style="`visibility: ${day !== 1 ?  'hidden' : 'visible'}`"
        @click="() => day = 2"
      >
        11/9(日)を表示 
      </button>
      <button
        v-if="day == 2"
        class="btn btn-primary"
        :style="`visibility: ${day !== 2 ?  'hidden' : 'visible'}`"
        @click="() => day = 1"
      >
        11/8(土)を表示 
      </button>
      <NuxtLink class="btn btn-primary" to="/pdf/timetable.pdf" target="_blank">
        PDFで開く
      </NuxtLink>
    </div>
  </article>
</template>